const tabsdropdown = {
  props: {
    dynamicClass: ".c-tabsdropdown.dynamicLoading",
    cssSelectorItem: "c-tabsdropdown",
    cssSelectorToggle: "c-tabsdropdown__dropdown-JS",
    cssSelectorContent: "c-tabsdropdown__tabpanel-JS",
    classSelectorActive: "active-JS",
    cssSelectorDropdownOpen: "mod--active",
    paramMain: "main",
    paramSection: "section",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-tabsdropdown.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document,
      items = baseFind.getElementsByClassName(this.props.cssSelectorItem);

    for (let k = 0; k < items.length; k++) {
      this.initDropdown(items[k]);
    }
    this.anchorForm();
  },

  anchorForm: function () {
    const queryString = location.search.replace("?", "").split("&");
    if (queryString) {
      for (let i = 0; i < queryString.length; i++) {
        const paramValue = queryString[i].split("=");
        if (paramValue.length > 0) {
          if (paramValue[0] == this.props.paramMain || paramValue[0] == this.props.paramSection) {
            this.clickInAnchor(paramValue[1]);
          }
        }
      }
    }
  },

  clickInAnchor: function (value) {
    const element = document.querySelector('li[data-name="' + value + '"]');
    if (element) {
      element.click();
    }
  },

  initDropdown: function ($element) {
    const $select = $element.getElementsByClassName(this.props.cssSelectorToggle);

    if (!$select) {
      return;
    }

    this.initListeners($element, $select[0]);

    if (!$element && !bcl.editMode) {
      return;
    }

    if (window.Granite && window.window.Granite.author && window.window.Granite.author.MessageChannel) {
      new window.window.Granite.author.MessageChannel("cqauthor", window).subscribeRequestMessage("cmp.panelcontainer", (message) => {
        if (message.data && message.data.id === $element.dataset["cmpPanelcontainerId"]) {
          if (message.data.operation === "navigate") {
            this.hideAllTabs($element);
            this.openTab($element, $select[0], this.getDropdownItemByValue($select[0], "tab" + message.data.index));
          }
        }
      });
    }
  },

  getDropdownItemByValue: function ($select, value) {
    let $item = null;
    bcl.u.forEach($select.getElementsByClassName("c-dropdown__select-list-item"), function ($loopItem) {
      if ($loopItem.dataset.value === value) {
        $item = $loopItem;
        return;
      }
    });
    return $item;
  },

  initListeners: function ($element, $select) {
    const input = $select.getElementsByClassName("c-dropdown__select-input")[0];

    if (input) {
      input.addEventListener("click", () => {
        this.openDropdown($select);
      });

      window.addEventListener("click", (e) => {
        if (!$select.contains(e.target)) {
          this.closeDropdown($select);
        }
      });

      bcl.u.forEach($select.getElementsByClassName("c-dropdown__select-list-item"), ($item) => {
        $item.addEventListener("click", () => {
          this.click($element, $select, $item);
        });
      });
    }
  },

  openDropdown: function ($select) {
    bcl.u.addClass($select.getElementsByClassName("c-dropdown__select-list--wrapper")[0], this.props.cssSelectorDropdownOpen);
  },

  closeDropdown: function ($select, value) {
    bcl.u.removeClass($select.getElementsByClassName("c-dropdown__select-list--wrapper")[0], this.props.cssSelectorDropdownOpen);
    if (value) {
      $select.getElementsByClassName("c-dropdown__select-input")[0].setAttribute("value", value.trim());
    }
  },

  click: function ($elem, $select, $item) {
    this.hideAllTabs($elem);
    this.openTab($elem, $select, $item);
  },

  hideAllTabs: function ($elem) {
    const tabs = $elem.getElementsByClassName(this.props.cssSelectorContent);
    for (let k = 0; k < tabs.length; k++) {
      if (tabs[k].parentNode == $elem) {
        bcl.u.removeClass(tabs[k], this.props.classSelectorActive);
      }
    }
  },

  openTab: function ($elem, $select, $item) {
    const tabs = $elem.getElementsByClassName(this.props.cssSelectorContent);
    for (let k = 0; k < tabs.length; k++) {
      const tab = tabs[k];
      if (tab.dataset.tab === $item.dataset.value && tab.parentNode == $elem) {
        bcl.u.addClass(tab, this.props.classSelectorActive);
        this.closeDropdown($select, $item.innerText);
        return;
      }
    }
  },
};

export default tabsdropdown;
